module.exports = __webpack_public_path__ + "img/logo-homepage.f8a68e1e.svg";